export default "__VITE_ASSET__B8i2mOt3__"